import { useEffect, useRef, useState } from "react";

/* ====== URL DE TU GOOGLE APPS SCRIPT (termina en /exec) ====== */
const URL_APPS_SCRIPT = "https://script.google.com/macros/s/AKfycbxkvPkgyGQ45ajTXy0MDz_lqwc4zRPcWt2GeS-L38q8LrAVt7PfQENBJS_oe6xah4-v/exec";
/* ============================================================= */

const CATEGORIAS = {
  "Presentación del stand": [
    ["Creatividad y diseño", "El stand es original, atractivo y logra destacarse visualmente."],
    ["Calidad de la presentación", "Los elementos están cuidados, ordenados, bien terminados y mantienen una estética armoniosa."],
    ["Coherencia con la empresa", "El stand refleja claramente la identidad, el propósito y la propuesta de la empresa juvenil."],
    ["Exhibición e información", "Permite comprender fácilmente qué ofrece la empresa e incluye información relevante sobre el producto o servicio, los canales de contacto y/o el proceso de producción."]
  ],
  "Presentación oral (pitch)": [
    ["Claridad del discurso", "La presentación es ordenada, comprensible y permite identificar el problema, la solución y la propuesta de valor."],
    ["Conocimiento del producto o servicio", "Explican con seguridad sus características, funcionamiento, beneficios, precio y elementos diferenciales."],
    ["Capacidad de persuasión", "El discurso resulta convincente, genera interés y comunica claramente por qué elegir la propuesta."],
    ["Actitud de venta", "El equipo demuestra entusiasmo, seguridad, preparación e iniciativa para avanzar hacia una venta."]
  ],
  "Atención al público": [
    ["Recepción y atención", "Reciben al público con amabilidad, respeto e interés, generando una buena primera impresión."],
    ["Escucha y adaptación", "Identifican las necesidades o intereses de cada persona y adaptan la explicación o recomendación."],
    ["Interacción con la propuesta", "Generan una experiencia que permite conocer, probar, observar o comprender el producto o servicio."],
    ["Coordinación y cierre", "El equipo se complementa, mantiene un discurso alineado y cierra adecuadamente la interacción, haya o no una venta."]
  ],
  "Producto o servicio": [
    ["Funcionalidad", "El producto o servicio funciona correctamente y responde a la necesidad o problema que busca resolver."],
    ["Calidad de ejecución", "Los materiales, recursos y procesos utilizados son adecuados y evidencian cuidado y atención al detalle."],
    ["Diseño y terminaciones", "La presentación final es atractiva, coherente y está bien resuelta, con pocos o ningún detalle pendiente."],
    ["Innovación y valor diferencial", "La solución presenta elementos originales, creativos o diferenciales frente a otras alternativas."]
  ]
};

const ESCALA = [
  ["1", "Muy insuficiente"],
  ["2", "Insuficiente"],
  ["3", "Adecuado"],
  ["4", "Muy bueno"],
  ["5", "Excelente"]
];

const CATS = Object.keys(CATEGORIAS);

const CSS = `
  :root{
    --aqua:#00C0CA;
    --aqua-dark:#008d95;
    --sky:#99D9DF;
    --ice:#C2EDF0;
    --pearl:#EEF3F4;
    --lime:#8FC440;
    --green:#BBD153;
    --yellow:#E3E24F;
    --ink:#22404D;
    --muted:#5d7679;
    --line:#cfe4e6;
    --card:#ffffff;
    --shadow:0 3px 16px rgba(0,141,149,.10);
  }
  .ej-app *{box-sizing:border-box;}
  .ej-app{
    margin:0;
    font-family:"Montserrat",system-ui,-apple-system,sans-serif;
    background:#ffffff;
    color:var(--ink);
    line-height:1.5;
    padding:24px 16px 80px;
  }
  .ej-app .wrap{max-width:760px;margin:0 auto;}
  .ej-app header.top{text-align:center;margin-bottom:26px;}
  .ej-app .kite{width:46px;height:46px;margin:0 auto 10px;display:block;}
  .ej-app header.top .eyebrow{
    font-size:.72rem;letter-spacing:.24em;text-transform:uppercase;
    color:var(--aqua-dark);font-weight:800;
  }
  .ej-app header.top h1{
    font-family:"Montserrat",sans-serif;font-weight:900;
    font-size:2rem;margin:.12em 0 .12em;letter-spacing:-.02em;
  }
  .ej-app header.top p{color:var(--muted);margin:0;font-size:.95rem;}

  .ej-app .selectors{margin-bottom:24px;}
  .ej-app .field label{
    display:block;font-size:.75rem;font-weight:800;letter-spacing:.05em;
    text-transform:uppercase;color:var(--aqua-dark);margin-bottom:6px;
  }
  .ej-app select{
    width:100%;padding:12px 14px;border:1.5px solid var(--line);border-radius:10px;
    background:var(--card);font-size:1rem;color:var(--ink);appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%2300C0CA' d='M6 8L0 0h12z'/%3E%3C/svg%3E");
    background-repeat:no-repeat;background-position:right 14px center;
  }
  .ej-app select:disabled{opacity:.6;cursor:not-allowed;}
  .ej-app select:focus{outline:2px solid var(--aqua);border-color:var(--aqua);}

  .ej-app .cat-header{
    background:var(--aqua);color:#fff;border-radius:10px;
    padding:12px 16px;margin:30px 0 16px;
    font-family:"Montserrat",sans-serif;font-weight:900;font-size:1.15rem;
    display:flex;align-items:center;gap:10px;
  }
  .ej-app .cat-header .num{
    background:rgba(255,255,255,.25);border-radius:50%;
    width:28px;height:28px;display:inline-flex;align-items:center;justify-content:center;
    font-size:.9rem;flex:0 0 auto;
  }

  .ej-app .criterion{
    background:var(--card);border:1px solid var(--line);border-radius:12px;
    padding:16px 18px;margin-bottom:14px;box-shadow:var(--shadow);
  }
  .ej-app .criterion h3{margin:0 0 4px;font-size:1.05rem;}
  .ej-app .criterion p{margin:0 0 12px;font-size:.9rem;color:var(--muted);}
  .ej-app .scale{display:flex;gap:8px;flex-wrap:wrap;}
  .ej-app .scale label{
    flex:1;min-width:52px;text-align:center;border:1.5px solid var(--line);
    border-radius:8px;padding:10px 4px;cursor:pointer;font-weight:800;font-size:1.05rem;
    transition:all .12s ease;user-select:none;background:#fbfefe;
    min-width:0;overflow:hidden;
  }
  .ej-app .scale label small{
    display:block;font-size:.58rem;font-weight:700;letter-spacing:.02em;
    color:var(--muted);text-transform:uppercase;margin-top:2px;
    line-height:1.15;word-break:break-word;hyphens:auto;
  }
  @media(max-width:520px){
    .ej-app .scale{gap:5px;}
    .ej-app .scale label{padding:9px 2px;font-size:1rem;}
    .ej-app .scale label small{font-size:.5rem;letter-spacing:0;}
  }
  .ej-app .scale input{position:absolute;opacity:0;width:0;height:0;}
  .ej-app .scale label:hover{border-color:var(--aqua);}
  .ej-app .scale input:checked + label{
    background:var(--aqua);border-color:var(--aqua-dark);color:#fff;
    box-shadow:0 2px 8px rgba(0,192,202,.35);
  }
  .ej-app .scale input:checked + label small{color:#e7fbfc;}

  .ej-app .comments{margin-top:20px;}
  .ej-app .comments label{
    display:block;font-size:.75rem;font-weight:800;letter-spacing:.05em;
    text-transform:uppercase;color:var(--aqua-dark);margin-bottom:6px;
  }
  .ej-app textarea{
    width:100%;min-height:70px;padding:12px 14px;border:1.5px solid var(--line);
    border-radius:10px;font-size:1rem;font-family:inherit;resize:vertical;
  }
  .ej-app textarea:focus{outline:2px solid var(--aqua);border-color:var(--aqua);}

  .ej-app .send-bar{
    margin-top:34px;background:var(--card);border:1px solid var(--line);
    border-radius:12px;padding:18px;box-shadow:var(--shadow);
    border-top:5px solid var(--lime);
  }
  .ej-app .send-bar .row{
    display:flex;justify-content:space-between;align-items:baseline;
    border-bottom:1px dashed var(--line);padding:8px 0;font-size:.95rem;
  }
  .ej-app .send-bar .row:last-of-type{border-bottom:none;}
  .ej-app .send-bar .big{font-family:"Montserrat",sans-serif;font-weight:900;color:var(--aqua-dark);}
  .ej-app .actions{display:flex;gap:12px;margin-top:20px;flex-wrap:wrap;}
  .ej-app button{
    flex:1;min-width:140px;padding:14px;border:none;border-radius:10px;
    font-size:1rem;font-weight:800;cursor:pointer;
  }
  .ej-app .btn-primary{background:var(--aqua);color:#fff;}
  .ej-app .btn-primary:hover{background:var(--aqua-dark);}
  .ej-app .btn-ghost{background:transparent;border:1.5px solid var(--line);color:var(--ink);}
  .ej-app .btn-ghost:hover{border-color:var(--lime);}
  .ej-app .hint{text-align:center;color:var(--muted);font-size:.9rem;padding:40px 20px;}

  .ej-app .modal-overlay{
    position:fixed;inset:0;background:rgba(34,64,77,.55);
    display:none;align-items:center;justify-content:center;padding:20px;z-index:50;
  }
  .ej-app .modal-overlay.show{display:flex;}
  .ej-app .modal-box{
    background:#fff;border-radius:16px;padding:30px 26px;max-width:380px;width:100%;
    text-align:center;box-shadow:0 18px 50px rgba(34,64,77,.28);
    border-top:6px solid var(--lime);animation:ej-pop .22s ease;
  }
  @keyframes ej-pop{from{transform:scale(.9);opacity:0;}to{transform:scale(1);opacity:1;}}
  .ej-app .modal-check{width:64px;height:64px;margin:0 auto 14px;}
  .ej-app .modal-box h2{font-family:"Montserrat",sans-serif;font-weight:900;font-size:1.3rem;margin:0 0 8px;color:var(--aqua-dark);}
  .ej-app .modal-box p{color:var(--muted);font-size:.95rem;margin:0 0 20px;}
  .ej-app .modal-box button{width:100%;}
  .ej-app .spinner{
    width:48px;height:48px;margin:0 auto 16px;
    border:5px solid var(--ice);border-top-color:var(--aqua);
    border-radius:50%;animation:ej-spin .8s linear infinite;
  }
  @keyframes ej-spin{to{transform:rotate(360deg);}}
`;

export default function EvaluacionStands() {
  const [jurados, setJurados] = useState({}); // { "Nombre jurado": ["EJ 1", ...] }
  const [completas, setCompletas] = useState(new Set()); // pares "jurado||ej"
  const [juradoOptionText, setJuradoOptionText] = useState("Cargando jurados…");
  const [juradoValue, setJuradoValue] = useState("");
  const [standValue, setStandValue] = useState("");
  const [pendientes, setPendientes] = useState(null); // null: sin jurado; []: todas evaluadas
  const [completasListas, setCompletasListas] = useState(false); // ya llegó el cálculo de fondo
  const [enviando, setEnviando] = useState(false); // muestra el pop-up mientras se guarda
  const [modal, setModal] = useState({ show: false, text: "" });

  const contRef = useRef(null);

  // Carga fuente Montserrat (equivalente a los <link> del <head>)
  useEffect(() => {
    const l1 = document.createElement("link");
    l1.rel = "preconnect";
    l1.href = "https://fonts.googleapis.com";
    const l2 = document.createElement("link");
    l2.rel = "preconnect";
    l2.href = "https://fonts.gstatic.com";
    l2.crossOrigin = "anonymous";
    const l3 = document.createElement("link");
    l3.rel = "stylesheet";
    l3.href = "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,600;0,700;0,800;0,900&display=swap";
    document.head.appendChild(l1);
    document.head.appendChild(l2);
    document.head.appendChild(l3);
    return () => {
      document.head.removeChild(l1);
      document.head.removeChild(l2);
      document.head.removeChild(l3);
    };
  }, []);

  // 1) Carga RÁPIDA: solo los jurados (llena el desplegable al instante)
  useEffect(() => {
    fetch(URL_APPS_SCRIPT + "?modo=jurados")
      .then((r) => r.json())
      .then((data) => {
        if (!data.ok || !data.jurados) {
          setJuradoOptionText("Error al cargar jurados");
          return;
        }
        const J = {};
        data.jurados.forEach((j) => {
          J[j.jurado] = j.ejs;
        });
        setJurados(J);
        setJuradoOptionText("Elegí tu nombre…");
      })
      .catch(() => {
        setJuradoOptionText("Error de conexión");
      });

    // 2) Carga en SEGUNDO PLANO: las EJ ya completadas (no bloquea la vista)
    fetch(URL_APPS_SCRIPT + "?modo=completas")
      .then((r) => r.json())
      .then((data) => {
        if (data && data.ok && data.completas) {
          setCompletas(new Set(data.completas));
        }
      })
      .catch(() => {})
      .finally(() => {
        setCompletasListas(true);
      });
  }, []);

  // Cuando llegan las "completas" (o cambian), re-filtra las EJ del jurado ya elegido
  useEffect(() => {
    if (juradoValue) {
      const asignadas = jurados[juradoValue] || [];
      setPendientes(asignadas.filter((ej) => !completas.has(juradoValue + "||" + ej)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [completas]);

  // Al elegir jurado, calcula las EJ pendientes (sin las ya evaluadas)
  function onJuradoChange(jurado) {
    setJuradoValue(jurado);
    setStandValue("");
    const asignadas = jurados[jurado] || [];
    const pend = asignadas.filter((ej) => !completas.has(jurado + "||" + ej));
    setPendientes(pend);
  }

  function onStandChange(stand) {
    setStandValue(stand);
    // recalc de todas las categorías tras render
    setTimeout(() => CATS.forEach((_, ci) => recalc(ci)), 0);
  }

  function recalc(ci) {
    const root = contRef.current;
    if (!root) return;
    let done = 0;
    let sumaProms = 0,
      catsConProm = 0;

    CATS.forEach((_, k) => {
      const nk = CATEGORIAS[CATS[k]].length;
      let sum = 0,
        count = 0,
        ok = true;
      for (let i = 0; i < nk; i++) {
        const sel = root.querySelector('input[name="cat' + k + '_crit' + i + '"]:checked');
        if (sel) {
          sum += parseInt(sel.value);
          count++;
        } else {
          ok = false;
        }
      }
      const avgEl = root.querySelector("#avg" + k);
      if (avgEl) avgEl.textContent = count ? (sum / count).toFixed(1) : "\u2013";
      if (ok) {
        done++;
        sumaProms += sum / nk;
        catsConProm++;
      }
    });

    const cd = root.querySelector("#catsDone");
    if (cd) cd.textContent = done + " / " + CATS.length;

    const gen = root.querySelector("#avgGeneral");
    if (gen) gen.textContent = catsConProm ? (sumaProms / catsConProm).toFixed(2) : "\u2013";
  }

  function enviar() {
    const root = contRef.current;
    const stand = standValue;
    const jurado = juradoValue;
    if (!jurado) {
      alert("Eleg\u00ED tu nombre de jurado antes de enviar.");
      return;
    }
    if (!stand) {
      alert("Eleg\u00ED una EJ antes de enviar.");
      return;
    }

    // valida que TODAS las categorías estén completas
    let faltantes = [];
    CATS.forEach((cat, ci) => {
      const n = CATEGORIAS[cat].length;
      for (let i = 0; i < n; i++) {
        if (!root.querySelector('input[name="cat' + ci + '_crit' + i + '"]:checked')) {
          faltantes.push(cat);
          break;
        }
      }
    });
    if (faltantes.length) {
      alert("Faltan criterios por completar en:\n\n\u2022 " + faltantes.join("\n\u2022 "));
      return;
    }

    // arma un envío por cada categoría
    const envios = CATS.map((cat, ci) => {
      const crits = CATEGORIAS[cat];
      const puntajes = [];
      let sum = 0;
      for (let i = 0; i < crits.length; i++) {
        const v = root.querySelector('input[name="cat' + ci + '_crit' + i + '"]:checked').value;
        puntajes.push(v);
        sum += parseInt(v);
      }
      const obs = root.querySelector("#obs" + ci).value.trim();
      return {
        jurado: jurado,
        stand: stand,
        categoria: cat,
        c1: puntajes[0] || "",
        c2: puntajes[1] || "",
        c3: puntajes[2] || "",
        c4: puntajes[3] || "",
        total: sum + " / " + (crits.length * 5),
        promedio: (sum / crits.length).toFixed(1),
        observaciones: obs
      };
    });

    const btn = root.querySelector(".send-bar .btn-primary");

    if (!URL_APPS_SCRIPT) {
      mostrarModal(stand);
      return;
    }

    setEnviando(true);
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Enviando\u2026";
    }

    // envía las 4 categorías
    Promise.all(
      envios.map((datos) =>
        fetch(URL_APPS_SCRIPT, {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: JSON.stringify(datos)
        }).catch(() => {})
      )
    )
      .then(() => {
        // Marca esta EJ como completa para este jurado (sin recargar)
        setCompletas((prev) => {
          const n = new Set(prev);
          n.add(jurado + "||" + stand);
          return n;
        });
        mostrarModal(stand);
      })
      .finally(() => {
        setEnviando(false);
        if (btn) {
          btn.disabled = false;
          btn.textContent = "Enviar evaluaci\u00F3n completa";
        }
      });
  }

  function mostrarModal(stand) {
    setModal({
      show: true,
      text: "Las 4 categor\u00edas de \u201C" + stand + "\u201D se guardaron correctamente."
    });
  }

  function cerrarModal() {
    setModal({ show: false, text: "" });
    // Regenera el desplegable de EJ: la recién evaluada ya no aparece
    onJuradoChange(juradoValue);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function limpiar() {
    const root = contRef.current;
    if (root) {
      root.querySelectorAll('input[type="radio"]').forEach((r) => (r.checked = false));
      root.querySelectorAll("textarea").forEach((t) => (t.value = ""));
      CATS.forEach((_, ci) => recalc(ci));
    }
  }

  // Opciones del desplegable de EJ
  let standOptions;
  if (pendientes === null) {
    standOptions = (
      <option value="" disabled>
        Elegí primero un jurado…
      </option>
    );
  } else if (pendientes.length === 0) {
    // Si el cálculo de fondo aún no llegó, no afirmamos "ya evaluaste todas"
    standOptions = (
      <option value="" disabled>
        {completasListas ? "Ya evaluaste todas tus EJ ✓" : "Verificando tus EJ…"}
      </option>
    );
  } else {
    standOptions = [
      <option key="_ph" value="" disabled>
        Elegí la EJ…
      </option>,
      ...pendientes.map((ej) => (
        <option key={ej} value={ej}>
          {ej}
        </option>
      ))
    ];
  }
  const standDisabled = pendientes === null || pendientes.length === 0;

  // Formulario de preguntas
  let preguntas;
  if (!standValue) {
    preguntas = <div className="hint">Elegí un jurado y una EJ para ver todas las categorías.</div>;
  } else {
    preguntas = (
      <>
        {CATS.map((cat, ci) => (
          <div key={cat}>
            <div className="cat-header">
              <span className="num">{ci + 1}</span>
              {cat}
            </div>
            {CATEGORIAS[cat].map((c, i) => {
              const name = "cat" + ci + "_crit" + i;
              return (
                <div className="criterion" key={i}>
                  <h3>{c[0]}</h3>
                  <p>{c[1]}</p>
                  <div className="scale">
                    {ESCALA.map((e) => {
                      const id = "cat" + ci + "_c" + i + "_" + e[0];
                      return (
                        <span key={e[0]} style={{ display: "contents" }}>
                          <input
                            type="radio"
                            name={name}
                            id={id}
                            value={e[0]}
                            onChange={() => recalc(ci)}
                          />
                          <label htmlFor={id}>
                            {e[0]}
                            <small>{e[1]}</small>
                          </label>
                        </span>
                      );
                    })}
                  </div>
                </div>
              );
            })}
            <div className="comments">
              <label htmlFor={"obs" + ci}>Observaciones — {cat}</label>
              <textarea id={"obs" + ci} placeholder="Comentarios, fortalezas, aspectos a mejorar…" />
            </div>
          </div>
        ))}

        <div className="send-bar">
          <div className="row">
            <span>Categorías completas</span>
            <span className="big" id="catsDone">
              0 / {CATS.length}
            </span>
          </div>
          {CATS.map((cat, ci) => (
            <div className="row" key={cat}>
              <span>{cat}</span>
              <span className="big" id={"avg" + ci}>
                {"\u2013"}
              </span>
            </div>
          ))}
          <div className="row">
            <span>
              <strong>Promedio general</strong>
            </span>
            <span className="big" id="avgGeneral">
              {"\u2013"}
            </span>
          </div>
          <div className="actions">
            <button className="btn-primary" onClick={enviar}>
              Enviar evaluación completa
            </button>
            <button className="btn-ghost" onClick={limpiar}>
              Limpiar
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="ej-app">
      <style>{CSS}</style>
      <div className="wrap">
        <header className="top">
          <div className="eyebrow">Empresas Juveniles</div>
          <h1>Evaluación de Stands</h1>
          <p>Elegí la EJ y completá las 4 categorías. Puntaje de 1 (muy insuficiente) a 5 (excelente).</p>
        </header>

        <div className="selectors">
          <div className="field">
            <label htmlFor="jurado">Jurado</label>
            <select
              id="jurado"
              value={juradoValue}
              onChange={(e) => onJuradoChange(e.target.value)}
            >
              <option value="" disabled>
                {juradoOptionText}
              </option>
              {Object.keys(jurados).map((j) => (
                <option key={j} value={j}>
                  {j}
                </option>
              ))}
            </select>
          </div>
          <div className="field" style={{ marginTop: "14px" }}>
            <label htmlFor="stand">Empresa Juvenil (EJ)</label>
            <select
              id="stand"
              value={standValue}
              disabled={standDisabled}
              onChange={(e) => onStandChange(e.target.value)}
            >
              {standOptions}
            </select>
          </div>
        </div>

        <div id="preguntas" ref={contRef}>
          {preguntas}
        </div>
      </div>

      <div className={"modal-overlay" + (enviando ? " show" : "")}>
        <div className="modal-box">
          <div className="spinner" />
          <h2>Enviando evaluación…</h2>
          <p>Estamos guardando las 4 categorías. Esto puede tardar unos segundos, no cierres la página.</p>
        </div>
      </div>

      <div className={"modal-overlay" + (modal.show ? " show" : "")}>
        <div className="modal-box">
          <div className="modal-check">
            <svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <circle cx="26" cy="26" r="24" fill="#8FC440" />
              <path
                d="M15 27 L23 35 L38 18"
                fill="none"
                stroke="#fff"
                strokeWidth="4.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h2>¡Evaluación enviada!</h2>
          <p>{modal.text}</p>
          <button className="btn-primary" onClick={cerrarModal}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}